import { RoutesService, eLayoutType } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];

function configureRoutes() {
  const routes = inject(RoutesService);

  routes.add([
    // === FLAT TOP-LEVEL ITEMS ===
    {
      path: '/dashboard',
      name: '::Menu:Home',
      iconClass: 'fas fa-home',
      order: 1,
      layout: eLayoutType.application,
    },
    {
      path: '/status',
      name: '::Menu:Status',
      iconClass: 'fas fa-heartbeat',
      order: 2,
      layout: eLayoutType.application,
    },
    {
      path: '/goals',
      name: '::Menu:Goals',
      iconClass: 'fas fa-bullseye',
      order: 3,
      layout: eLayoutType.application,
    },
    {
      path: '/plans',
      name: '::Menu:Plans',
      iconClass: 'fas fa-calendar-check',
      order: 4,
      layout: eLayoutType.application,
    },
    {
      path: '/reports',
      name: '::Menu:Reports',
      iconClass: 'fas fa-chart-line',
      order: 5,
      layout: eLayoutType.application,
    },
    {
      path: '/ai-assistant',
      name: '::Menu:AiAssistant',
      iconClass: 'fas fa-robot',
      order: 6,
      layout: eLayoutType.application,
    },
    {
      path: '/people',
      name: '::Menu:People',
      iconClass: 'fas fa-user-friends',
      order: 7,
      layout: eLayoutType.application,
    },
    {
      path: '/overview',
      name: '::Menu:Overview',
      iconClass: 'fas fa-th-large',
      order: 8,
      layout: eLayoutType.application,
    },

    // === FORMLAR GROUP ===
    {
      path: '',
      name: '::Menu:FormsGroup',
      iconClass: 'fas fa-file-alt',
      order: 9,
      layout: eLayoutType.application,
    },
    {
      path: '/forms/pending',
      name: '::Menu:PendingForms',
      parentName: '::Menu:FormsGroup',
      iconClass: 'fas fa-clock',
      order: 1,
      layout: eLayoutType.application,
    },
    {
      path: '/admin/form-templates',
      name: '::Menu:FormBuilder',
      parentName: '::Menu:FormsGroup',
      iconClass: 'fas fa-tools',
      order: 2,
      layout: eLayoutType.application,
    },
    {
      path: '/forms/assignments',
      name: '::Menu:FormAssignments',
      parentName: '::Menu:FormsGroup',
      iconClass: 'fas fa-tasks',
      order: 3,
      layout: eLayoutType.application,
    },

    // === AYARLAR GROUP ===
    {
      path: '',
      name: '::Menu:SettingsGroup',
      iconClass: 'fas fa-cog',
      order: 10,
      layout: eLayoutType.application,
    },
    {
      path: '/account/manage',
      name: '::Menu:AccountSettings',
      parentName: '::Menu:SettingsGroup',
      iconClass: 'fas fa-user-cog',
      order: 1,
      layout: eLayoutType.application,
    },
    {
      path: '/settings/notifications',
      name: '::Menu:NotificationSettings',
      parentName: '::Menu:SettingsGroup',
      iconClass: 'fas fa-bell',
      order: 2,
      layout: eLayoutType.application,
    },
    {
      path: '/setting-management',
      name: '::Menu:LanguageSettings',
      parentName: '::Menu:SettingsGroup',
      iconClass: 'fas fa-globe',
      order: 3,
      layout: eLayoutType.application,
    },

    // === YÖNETİM GROUP ===
    {
      path: '',
      name: '::Menu:Administration',
      iconClass: 'fas fa-shield-alt',
      order: 100,
      layout: eLayoutType.application,
      requiredPolicy: 'AbpIdentity.Users',
    },
    {
      path: '/identity/users',
      name: '::Menu:Users',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-users',
      order: 1,
      layout: eLayoutType.application,
      requiredPolicy: 'AbpIdentity.Users',
    },
    {
      path: '/identity/roles',
      name: '::Menu:Roles',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-id-card',
      order: 2,
      layout: eLayoutType.application,
      requiredPolicy: 'AbpIdentity.Roles',
    },
    {
      path: '/admin/schools',
      name: '::Menu:Schools',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-school',
      order: 3,
      layout: eLayoutType.application,
    },
    {
      path: '/admin/cities',
      name: '::Menu:Cities',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-city',
      order: 4,
      layout: eLayoutType.application,
    },
    {
      path: '/admin/grade-levels',
      name: '::Menu:GradeLevels',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-layer-group',
      order: 5,
      layout: eLayoutType.application,
    },
    {
      path: '/admin/form-templates',
      name: '::Menu:FormTemplates',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-file-invoice',
      order: 6,
      layout: eLayoutType.application,
    },
    {
      path: '/admin/parameters',
      name: '::Menu:Parameters',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-sliders-h',
      order: 7,
      layout: eLayoutType.application,
    },
    {
      path: '/admin/coaches',
      name: '::Menu:CoachApprovals',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-user-check',
      order: 8,
      layout: eLayoutType.application,
    },
    {
      path: '/admin/logs',
      name: '::Menu:SystemLogs',
      parentName: '::Menu:Administration',
      iconClass: 'fas fa-clipboard-list',
      order: 9,
      layout: eLayoutType.application,
    },
  ]);
}
